/**
 * The bare React context for AuthConfig. Lives in its own file so neither
 * the provider component nor the hook re-exports it as a side effect — the
 * fast-refresh rule rejects mixing component and non-component exports.
 */

import { createContext } from "react";
import type { AuthConfig } from "@/shared/api/auth-config";

export const AuthConfigContext = createContext<AuthConfig | null>(null);
